import { ICareerSkillNode } from 'core/hooks/CareerSkillGraph/transform/transformCareerSkillGraph';

import { ISkillGraphIndex } from './skillGraphModel';

/**
 * Поиск навыка по карте (ТЗ 0070).
 *
 * 🔴 Диакритика снимается, иначе поиск молча не работает на трети польских
 * слов: человек печатает «srodowisko», а в справочнике «środowisko».
 *
 * ⚠️ И отдельная ловушка польского: `ł` под NFD НЕ раскладывается — это
 * самостоятельный символ, а не «l с чёрточкой». Нормализация Unicode его не
 * тронет, поэтому пары вроде `ł→l` перечислены руками. Без этой карты
 * «kubernetes» найдётся, а «Zarządzanie kodem» — нет.
 */
const HARD_PAIRS: Record<string, string> = {
  ł: 'l',
  Ł: 'l',
  đ: 'd',
  Đ: 'd',
  ø: 'o',
  Ø: 'o',
};

export const normalizeQuery = (value: string): string =>
  (value || '')
    .replace(/[łŁđĐøØ]/g, (char) => HARD_PAIRS[char] || char)
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .trim();

/**
 * Совпадения по названию и слагу. Порядок — тот же, что на карте: список,
 * который переставляется между нажатиями, невозможно читать.
 */
export const matchSkills = (index: ISkillGraphIndex, query: string): ICareerSkillNode[] => {
  const needle = normalizeQuery(query);
  if (needle.length < 2) return [];

  const out: ICareerSkillNode[] = [];
  index.clusters.forEach((cluster) => {
    (index.nodesOf.get(cluster.code) || []).forEach((node) => {
      const haystack = `${normalizeQuery(node.name)} ${normalizeQuery(node.slug)}`;
      if (haystack.includes(needle)) out.push(node);
    });
  });
  return out;
};
